t = require('views/internal/teacup-with-helpers')('soft_block')

module.exports = ->
  t.div ->
    t.div '.soft-block-image-container', ->
      t.img { src: require('images/soft-block.svg') }
    t.div '.soft-block-text', ->
      t.div '.soft-block-logo', ->
        t.img { src: require('images/trello-logo-blue.svg') }
      t.h2 ->
        t.format 'try-trello-its-free'
      t.p ->
        t.format 'join-35-million-people-already-using-trello'
      t.a '.js-soft-block-signup.mod-inline-block.button-link.highlight', { href: '/signup' }, ->
        t.span -> t.format 'sign-up-for-free'
      t.a '.js-soft-block-learn-more.mod-inline-block.button-link', { href: '/home' }, ->
        t.span -> t.format 'learn-more'
      t.span '.soft-block-learn-more', ->
        t.format 'already-have-an-account'
        t.raw '&nbsp;'
      t.a '.js-soft-block-login.mod-inline-block.soft-block-learn-more', { href: '/login' }, ->
        t.format 'log-in'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/soft_block.coffee